"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var Types = require("types");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var diaryEntryCommentActions = require("@caddigital/sok-reducers/lib/actions/diaryentries/comment");
require("./style.scss");
var react_router_dom_1 = require("react-router-dom");
var text_1 = require("utils/text");
var avatars_1 = require("components/Avatar/avatars");
var noPermissionsGranoManImage = 'Grano_SokoPro_avatar_9';
var moment = require("moment");
var mapStateToProps = function (state) {
    return {
        comments: state.diaryentries.comment,
        userInfo: state.auth.current.user
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetchComments: function (diaryId, entryId) {
        return dispatch(diaryEntryCommentActions.fetchRequest(diaryId, entryId));
    },
    createComment: function (diaryId, entryId, comment) {
        return dispatch(diaryEntryCommentActions.createCommentRequest(diaryId, entryId, comment));
    },
    clearState: function () { return dispatch(diaryEntryCommentActions.clear()); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('commentField', 'setCommentField', ''), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetchComments(this.props.diaryId, this.props.entryId);
    },
    componentWillReceiveProps: function (nextProps) {
        if (this.props.comments.status !== nextProps.comments.status &&
            nextProps.comments.status === 'CREATED') {
            this.props.fetchComments(nextProps.diaryId, nextProps.entryId);
        }
    },
    componentWillUnmount: function () {
        this.props.clearState();
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    var commentDataSorted = __spreadArray([], props.comments.comments, true).sort(function (a, b) { return b.created_at - a.created_at; });
    return (React.createElement("div", { className: 'diaryentry-additional-comments' },
        React.createElement(sok_ui_1.AccordionPanel, { title: (0, translation_1.getLocalization)('diaryEntryView/additionalComments') },
            acl.hasGrant(props.perm, acl.SUPER_ADMIN_GRANT) ||
                acl.hasGrant(props.worksiteDiaryPerm, acl.WORKSITE_DIARY_MASTER_GRANT) ||
                acl.hasGrant(props.worksiteDiaryPerm, acl.WORKSITE_DIARY_SUPERVISOR_GRANT) ? (React.createElement("div", { className: 'input-and-add-button' },
                React.createElement("div", { className: 'circle' },
                    React.createElement("img", { className: "user-icon", src: props.userInfo
                            .map(function (info) { return (0, avatars_1.getAvatarUrl)(info.avatar); })
                            .getOrElse((0, avatars_1.getAvatarUrl)(noPermissionsGranoManImage)) })),
                React.createElement(sok_ui_1.TextInput, { className: 'comment-input-box', value: props.commentField, onChange: function (e) {
                        return props.setCommentField(e.target.value);
                    } }),
                React.createElement(sok_ui_1.Button, { className: !props.isMobile
                        ? 'add-comment-button'
                        : 'add-comment-button-mobile', color: "blue", disabled: props.commentField.length === 0, icon: props.isMobile ? React.createElement(sok_ui_1.Icon, { className: "fa-plus" }) : null, onClick: function () {
                        props.createComment(props.diaryId, props.entryId, props.commentField);
                        props.setCommentField('');
                    } }, !props.isMobile
                    ? (0, translation_1.getLocalization)('diaryEntryView/additionalComments/add')
                    : null))) : null,
            React.createElement("div", { className: "comments-section" }, props.comments.comments.length > 0 &&
                commentDataSorted.map(function (comment) {
                    if (!comment.user) {
                        // If user has been deleted, backend doesn't send full user data
                        return (React.createElement("div", { className: 'comment-row', key: comment.comment_uuid },
                            React.createElement("div", { className: 'circle comment-user-avatar-cirle' },
                                React.createElement("img", { className: "comment-user-avatar", src: (0, avatars_1.getAvatarUrl)(noPermissionsGranoManImage) })),
                            React.createElement("div", { className: "comment-contents" },
                                React.createElement("div", { className: "comment-time-and-user" },
                                    moment(comment.created_at).format('D.M.YYYY HH.mm'),
                                    comment.user_fullname),
                                React.createElement("div", { className: "comment-message-container" }, comment.comment))));
                    }
                    return (React.createElement("div", { className: 'comment-row', key: comment.comment_uuid },
                        React.createElement("div", { className: 'circle comment-user-avatar-cirle' },
                            React.createElement("img", { className: "comment-user-avatar", src: (0, avatars_1.getAvatarUrl)(comment.user.avatar) })),
                        React.createElement("div", { className: "comment-contents" },
                            React.createElement("div", { className: "comment-time-and-user" },
                                moment(comment.created_at).format('D.M.YYYY HH.mm'),
                                " (",
                                (0, text_1.capitalize)(comment.user.firstName),
                                ' ',
                                (0, text_1.capitalize)(comment.user.lastName),
                                ")"),
                            React.createElement("div", { className: "comment-message-container" }, comment.comment))));
                })))));
});
